import { z } from 'zod';

/**
 * グループ作成フォームのバリデーションスキーマ
 *
 * @property name - グループ名（必須）
 * @property groupId - グループID（必須、英数字のみ）
 * @property description - 説明（任意、200文字以内）
 */
export const createGroupSchema = z.object({
  name: z.string().trim().min(1, 'グループ名を入力してください。'),
  groupId: z
    .string()
    .trim()
    .min(1, 'グループIDを入力してください。')
    .regex(/^[a-zA-Z0-9]+$/, '英数字のみ使用可能です。'),
  description: z.string().trim().max(200, '200文字以内で入力してください。').optional(),
});

/**
 * グループ作成フォームのフィールド値の型
 */
export type CreateGroupFormFieldValues = z.infer<typeof createGroupSchema>;
